import { render, staticRenderFns } from "./updatePermission.vue?vue&type=template&id=289aed7a"
import script from "./updatePermission.vue?vue&type=script&lang=js"
export * from "./updatePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports